import styled from 'styled-components';

export const StyledMainGrid = styled.div<{ $minWidth?: string }>`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(${({ $minWidth = '300px' }) => $minWidth}, 1fr)
  );
  gap: 25px;
  padding: 25px;
`;
